import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, MessageCircle, Instagram, Linkedin } from "lucide-react";
import { site } from "@/data/site";

export const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-black border-t border-white/10 pt-20 pb-10">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 pb-14">
          <div>
            <p className="font-heading font-extrabold text-2xl tracking-tight text-white">
              TESLA-VERLEIH-FRANKFURT
            </p>
            <p className="text-xs tracking-[0.3em] text-white/40 uppercase mt-2">
              Mobilitätsberatung
            </p>
            <p className="text-sm text-white/55 leading-relaxed mt-5 max-w-sm">
              Tesla-Verleih und ehrliche Mobilitätsberatung im Rhein-Main-Gebiet –
              persönlich, regional, zukunftsorientiert.
            </p>
            <div className="flex gap-3 mt-6">
              <a href={site.whatsapp} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp" className="w-10 h-10 rounded-full border border-white/15 flex items-center justify-center text-white hover:bg-white/10 transition-colors">
                <MessageCircle className="w-4 h-4" />
              </a>
              <a href={site.instagram} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" className="w-10 h-10 rounded-full border border-white/15 flex items-center justify-center text-white hover:bg-white/10 transition-colors">
                <Instagram className="w-4 h-4" />
              </a>
              <a href={site.linkedin} target="_blank" rel="noopener noreferrer" data-testid="footer-linkedin" className="w-10 h-10 rounded-full border border-white/15 flex items-center justify-center text-white hover:bg-white/10 transition-colors">
                <Linkedin className="w-4 h-4" />
              </a>
              <a href={`mailto:${site.email}`} data-testid="footer-mail" className="w-10 h-10 rounded-full border border-white/15 flex items-center justify-center text-white hover:bg-white/10 transition-colors">
                <Mail className="w-4 h-4" />
              </a>
            </div>
          </div>

          <div>
            <p className="text-xs uppercase tracking-[0.25em] text-white/40 mb-5">Kontakt</p>
            <ul className="space-y-4 text-sm text-white/65">
              <li>
                <a href={`tel:${site.phoneTel}`} className="flex items-center gap-3 hover:text-white transition-colors">
                  <Phone className="w-4 h-4" /> {site.phoneDisplay}
                </a>
              </li>
              <li>
                <a href={`mailto:${site.email}`} className="flex items-center gap-3 hover:text-white transition-colors">
                  <Mail className="w-4 h-4" /> {site.email}
                </a>
              </li>
              <li>
                <a href={site.maps} target="_blank" rel="noopener noreferrer" className="flex items-start gap-3 hover:text-white transition-colors">
                  <MapPin className="w-4 h-4 mt-0.5" />
                  <span>{site.street}<br />{site.city}</span>
                </a>
              </li>
            </ul>
          </div>

          <div>
            <p className="text-xs uppercase tracking-[0.25em] text-white/40 mb-5">Navigation</p>
            <ul className="space-y-3 text-sm text-white/65">
              <li><a href="#leistungen" className="hover:text-white transition-colors">Leistungen</a></li>
              <li><a href="#bewertungen" className="hover:text-white transition-colors">Bewertungen</a></li>
              <li><a href="#kontakt" className="hover:text-white transition-colors">Kontakt</a></li>
              <li><Link to="/impressum" data-testid="footer-impressum" className="hover:text-white transition-colors">Impressum</Link></li>
              <li><Link to="/datenschutz" data-testid="footer-datenschutz" className="hover:text-white transition-colors">Datenschutz</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/40">
            © {new Date().getFullYear()} Tesla-Verleih-Frankfurt · Mobilitätsberatung. Alle Rechte vorbehalten.
          </p>
          <p className="text-[11px] text-white/30">
            Tesla ist eine Marke der Tesla, Inc. Diese Seite steht in keiner Verbindung zu Tesla, Inc.
          </p>
        </div>
      </div>
    </footer>
  );
};
